import { AppBadge, type AppTone } from './AppUi'
import { formatMultiSelectLabel } from './formatMultiSelectLabel'
import { cx } from './utils'

export function MultiSelectFilterSummary<T extends string>({
  selected,
  getLabel,
  emptyLabel,
  getTone,
  className,
}: {
  selected: readonly T[]
  getLabel: (value: T) => string
  emptyLabel: string
  getTone?: (value: T) => AppTone | undefined
  className?: string
}) {
  const ariaLabel = formatMultiSelectLabel(selected, getLabel, emptyLabel)

  if (selected.length === 0) {
    return (
      <span className={cx('min-w-0 truncate text-sm', className)} aria-label={ariaLabel}>
        {emptyLabel}
      </span>
    )
  }

  return (
    <span
      className={cx(
        'flex min-w-0 flex-1 items-center gap-1 overflow-hidden',
        className,
      )}
      aria-label={ariaLabel}
    >
      {selected.map((value) => (
        <AppBadge
          key={value}
          tone={getTone?.(value) ?? 'zinc'}
          className="max-w-[9rem] shrink-0 truncate px-2 py-0.5 text-[11px] leading-tight"
        >
          {getLabel(value)}
        </AppBadge>
      ))}
    </span>
  )
}
